import axios from './config';

export const getPurchaseDetails = ({ queryStr }) => {
  return axios.get(`/purchase-details?${queryStr}`).then(res => res.data.data);
};
